var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ServiceLayout',{attrs:{"icon":"notext-stargroup.png","title":"StarGroup","description":"Cocok untuk anda yang ingin berpergian bersama keluarga besar atau teman-teman dengan kapasitas mulai dari 9-13 orang (hanya berlaku untuk perjalanan dalam kota).","extra_hour":1,"tariffs":_vm.stargroup_tariffs,"lists":_vm.stargroup_list}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5500e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Service/StarGroup.vue
// module id = null
// module chunks = 